import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const CustomerDetailsPageActionButtons = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { customers: c } = useTranslatedMessages();
  const actions = c?.actions ?? {};

  const onClickingBackButton = () => {
    return navigate('/customers');
  };

  return (
    <>
      <Button
        data-testid="customer-profile-back-button"
        key="back"
        variant="contained"
        color="primary"
        onClick={onClickingBackButton}
        className="action-button"
        sx={{ marginLeft: theme.spacing(1) }}
      >
        {actions.back ?? 'Back'}
      </Button>
    </>
  );
};

export default CustomerDetailsPageActionButtons;
